import { getSortedFormFields } from '@utils/forms';
import { helpWithOptions } from './NetworkingArubaCentralFormOptions';

export const getNetworkingArubaCentralFormData = (target, helpWith) => {
  if (helpWith === helpWithOptions.greenlakeSpecific) {
    const namespace = 'hpe_greenlake_user';
    const subject = `HPE Networking Aruba Central : ${helpWith} - {formId}`;
    return getSortedFormFields(target, namespace, subject);
  }
};
